























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import moment from "moment";
import TypesList from "./TypesList.vue";
import ExercisesList from "./ExercisesList.vue";

@Component({
  components: {
    ExercisesList,
    TypesList

  },
})
export default class SelectExerciseBlock extends Vue {
  private parentTypeId: string = '';
  private selectedTypeId: string = '';
  private style: string = '';
  private teacher: string = '';

  @Prop()
  private styleId?: string;

  @Prop()
  private teacherId?: string;

  @Watch('styleId')
  watchPropStyleId() {
    this.style = this.styleId || '';
  }

  @Watch('teacherId')
  watchPropTeacherId() {
    this.teacher = this.teacherId || '';
  }

  private handleSelectedParentType(typeId: string) {
    this.parentTypeId = typeId;
    this.selectedTypeId = typeId;
  }

  private handleSelectedChildType(typeId: string) {
    this.selectedTypeId = typeId;
  }

  private handleSelectedExercise(exerciseId: string) {
    this.$emit('selectedExercise', exerciseId)
  }
}
